import { render, staticRenderFns } from "./MuonitusOhje.vue?vue&type=template&id=346b2dec"
import script from "./MuonitusOhje.vue?vue&type=script&lang=js"
export * from "./MuonitusOhje.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports